import { Outlet } from "react-router-dom";
import { MarketplaceSearchProvider } from "../context/SearchContext";
import { TravelHeader } from "./TravelHeader";
import "../theme.css";

export function MemberLayout() {
  return (
    <MarketplaceSearchProvider>
      <div className="member-portal-v2 flex h-screen flex-col overflow-hidden bg-[#f5f5f5] text-[#1a1a1a]">
        <TravelHeader />
        <div className="min-h-0 flex-1 overflow-y-auto">
          <Outlet />
          <footer className="border-t border-[#e7e7e7] bg-white">
            <div className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-6 text-sm text-[#595959] sm:flex-row sm:items-center sm:justify-between sm:px-6">
              <p>Perk Point · Stays and flights for members</p>
              <p>Pay with cash and points. Bookings and points are saved to your membership.</p>
            </div>
          </footer>
        </div>
      </div>
    </MarketplaceSearchProvider>
  );
}
